(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fxl-supplier-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fxl-supplier-stock')) {
    const active = new Set();
    let timer;
    customElements.define('fxl-supplier-stock', class extends HTMLElement {
      connectedCallback() {
        this.quantity = this.dataset.compact === 'true' ? null : this.closest('.feestxl-product-section')?.querySelector('[data-feestxl-qty]');
        this.refresh = () => {
          const fresh = this.dataset.fresh === 'true' && (this.dataset.demo === 'true' || Date.now() < Number(this.dataset.expires) * 1000);
          const own = Number(this.dataset.own);
          const total = fresh ? Number(this.dataset.total) : own;
          const wanted = Math.max(1, Number(this.quantity?.value || this.dataset.wanted) || 1);
          this.querySelector('[data-supplier-current]').hidden = !fresh || Number(this.dataset.supplier) <= 0;
          this.querySelector('[data-supplier-unknown]').hidden = fresh;
          this.querySelector('[data-own-status]').hidden = own === 0 && fresh && Number(this.dataset.supplier) > 0;
          const shortage = this.querySelector('[data-supplier-shortage]');
          const delivery = this.querySelector('[data-supplier-delivery]');
          if (shortage) shortage.hidden = wanted <= total;
          if (delivery) delivery.hidden = !(fresh && own > 0 && wanted > own && wanted <= total);
        };
        this.quantity?.addEventListener('input', this.refresh);
        this.quantity?.addEventListener('change', this.refresh);
        this.refresh();
        active.add(this);
        if (!timer) timer = setInterval(() => active.forEach(element => element.refresh()), 30000);
      }
      disconnectedCallback() {
        active.delete(this);
        if (!active.size) { clearInterval(timer); timer = null; }
        this.quantity?.removeEventListener('input', this.refresh);
        this.quantity?.removeEventListener('change', this.refresh);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
